import * as React from 'react'
// libs
import { formValueSelector } from 'redux-form'
// types
import { IRisk } from 'types/graphql'

export declare namespace NRiskContext {
  export interface IContext {
    risk: IRisk
    form: string
    riskId: string
    isScheduled: boolean
    riskSelector: any
  }

  export interface IProps {
    risk: IRisk
    form: string
    children?: React.ReactNode
    isScheduled: boolean
  }
}

export const RiskViewContext = React.createContext<NRiskContext.IContext>({} as any)

const RiskViewProvider: React.FC<NRiskContext.IProps> = ({ children, risk, form, isScheduled }) => {
  const selector = React.useMemo(() => formValueSelector(form), [form])

  const value = {
    risk,
    form,
    isScheduled,
    riskId: risk.id,
    riskSelector: selector
  }

  return <RiskViewContext.Provider value={value}>{children}</RiskViewContext.Provider>
}

export default RiskViewProvider
